import {
  EmptyDataScreen,
  ErrorScreen,
  FileItem,
  IconButton,
  Loader,
  Panel,
  Row,
  RowSize,
} from "@/components";
import { NO_VALUE } from "@/constants";
import { InboxKeyParam } from "@/pages/inbox/types";
import { useRequestAttachmentsData } from "@/pages/requests/hooks/use-request-attachments-data";
import { formatFileSize } from "@/utils";
import { getFileSizeFromBase64 } from "@/utils/get-file-size-from-base64";
import { map } from "lodash";
import { FC, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./styles.scss";
import { AttachmentsSummaryProps } from "./types";
import { Download } from "@/assets/icons";
import { FileDataProps } from "@/services";
import { saveBase64ToFile } from "@/utils/get-base64";

export const AttachmentsSummary: FC<AttachmentsSummaryProps> = ({
  requestId,
}) => {
  const [searchParams] = useSearchParams();
  const referenceNumber = searchParams.get(InboxKeyParam.ReferenceNumber);

  const { isLoading, data, error } = useRequestAttachmentsData({
    requestId: requestId || referenceNumber,
    getFilesAsBase64: true,
  });

  const handleDownloadDocument = useCallback(
    (file?: FileDataProps, isTemplate?: boolean) => {
      if (file) {
        saveBase64ToFile(file, isTemplate); // file.name, file.base64 as string
      }
    },
    [],
  );

  const renderContent = () => {
    if (isLoading) {
      return <Loader />;
    }

    if (error) {
      return <ErrorScreen />;
    }

    // TODO Add interface and schema for data

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (!data.length) {
      return <EmptyDataScreen />;
    }

    return map(data, (attachment, i) => {
      const attachmentSize = getFileSizeFromBase64(attachment?.FileBase64);

      return (
        <Row
          size={RowSize.Small}
          className={styles.panelRow}
          key={`attachment-${i}`}
        >
          <div className={styles.panelRowTitle}>
            <span>{attachment?.DocNameEn}</span>
          </div>

          {attachment?.DocNameEn && (
            <div className={styles.panelRowFile}>
              <FileItem
                extension={
                  (attachment?.Format?.split(".")[1] || attachment?.Format) ??
                  null
                }
                fileName={attachment?.FileName || NO_VALUE}
              />
            </div>
          )}

          <span className={styles.panelRowFileSize}>
            <span>{formatFileSize(attachmentSize)}</span>
          </span>

          <div>
            <IconButton
              icon={Download}
              // className={styles.iconContainer}
              onClick={() => {
                handleDownloadDocument({
                  name: `${attachment?.FileName}`,
                  base64: attachment?.FileBase64,
                  type: `${attachment?.Format}`,
                  size: attachmentSize,
                } as FileDataProps);
              }}
            />
          </div>
        </Row>
      );
    });
  };

  return <Panel header="Attachments">{renderContent()}</Panel>;
};
